export function checkAlphabetsAndDotsOnly(value, setError, dispatch, errorFunction, section, key, errorMessage) {
  const regex = /^[A-Za-z\s.]*$/;
  // console.log("checkAlphabetsAndDotsOnly",value);
  if (!regex.test(value)) {
    setError();
    dispatch(
      errorFunction({
        message: errorMessage || "Incorrect format ",
        section: section,
        ...(key && { key: key + "FamilyError" })
      })
    );
  }

}


export const checkAlphabetsAndDotsOnly11 = (value, errorFunction, errorMessage, section) => {
  const regex = /^[a-zA-Z.]+$/;
  if (!regex.test(value)) {
    if (typeof errorFunction === "function") {
      errorFunction({
        message: errorMessage || "Incorrect format",
        section,
      });
    } else {
      console.error("Error function is not provided or not a function");
    }
    return false;
  }
  return true;
};

//for name check
export function validateNameField(value, fieldName, dispatch, setError, errorFunction, section, errorMessage) {
  const nameRegex = /^[A-Za-z\s.]*$/;
  if (!nameRegex.test(value)) {
    setError();
    dispatch(
      errorFunction({
        message: errorMessage || `Valid ${fieldName} is required`,
        section: section,
      })
    );
  } else {
    // Clear any existing error message if validation passes
    dispatch(errorFunction({ message: "", section: section }));
  }
  if (!value.trim()) {
    dispatch(errorFunction({ message: `${fieldName} is required`, section: section }));
  }
}

//for nameNepali check
export function validateNepaliNameField(value, fieldName, dispatch, setError, errorFunction, section, errorMessage) {
  const nameRegex = /^[\u0900-\u097F\u200D\s.]*$/; // Matches Nepali characters and spaces
  const trimmedValue = (value || "").trim();

  // If the value is empty, show required error
  if (!trimmedValue) {
    dispatch(
      errorFunction({
        message: `${fieldName} is required`,
        section: section,
      })
    );
    return;
  }
  // If the value does not match the Nepali regex, show validation error
  if (!nameRegex.test(trimmedValue)) {
    setError();
    dispatch(
      errorFunction({
        message: errorMessage || `Valid ${fieldName} is required`,
        section: section,
      })
    );
  } else {
    // Clear errors if validation passes
    dispatch(errorFunction({ message: "", section: section }));
  }
}

export function checkNepaliAlphabetsAndDotsOnly(value, setError, dispatch, errorFunction, section, errorMessage, key) {
  const nepaliRegex = /^[\u0900-\u097F\u200D\s.]*$/; // Matches Nepali characters and spaces
  if (!nepaliRegex.test(value)) {
    setError();
    dispatch(
      errorFunction({
        message: errorMessage || "Incorrect Nepali format",
        section: section,
        ...(key && { key: key + "FamilyError" })
      })
    );
  }
}

export const checkNepaliAlphabetsAndDotsOnly11 = (value, errorFunction, errorMessage, section) => {
  const nepaliRegex = /^[\u0900-\u097F\u200D\s.]*$/; // Matches Nepali characters and spaces
  if (!nepaliRegex.test(value)) {
    if (typeof errorFunction === "function") {
      errorFunction({
        message: errorMessage || "Incorrect Nepali format",
        section,
      });
    } else {
      console.error("Error function is not provided or not a function");
    }
    return false;
  }
  return true;
};

export function checkAlphabetsAndDotsAndMinusAndSmallBracketOnly(value, setError, dispatch, errorFunction, section, errorMessage) {
  const regex = /^[A-Za-z\s.\-()]*$/;
  // console.log("checkAlphabetsAndDotsOnly",value);
  if (!regex.test(value)) {
    setError();
    dispatch(
      errorFunction({
        message: errorMessage || "Incorrect format for alphabet validation",
        section: section,
      })
    );
  }

}

//company
export function checkAlphabetsAndDotsAndMinusAndSmallBracketOnlyCompany(value, fieldName, dispatch, setError, errorFunction, section, errorMessage) {
  const nameRegex = /^[A-Za-z\s.\-()]*$/;
  // console.log("checkAlphabetsAndDotsOnly",value);
  if (!nameRegex.test(value)) {
    setError();
    dispatch(
      errorFunction({
        message: errorMessage || `Valid ${fieldName} is required`,
        section: section,
      })
    );
  } else {
    // Clear any existing error message if validation passes
    dispatch(errorFunction({ message: "", section: section }));
  }
  if (!value.trim()) {
    dispatch(errorFunction({ message: `${fieldName} cant be empty.`, section: section }));
  }
}

export function checkAlphabetsAndDotsAndMinusAndSmallBracketOnlyCompanyNep(value, fieldName, dispatch, setError, errorFunction, section, errorMessage) {
  const nameRegex = /^[\u0900-\u097F\u200D\s.\-()]*$/; // Matches Nepali characters, spaces, dots, dashes, and small brackets
  const trimmedValue = (value || "").trim();

  // If the value is empty, show required error
  if (!trimmedValue) {
    dispatch(
      errorFunction({
        message: `${fieldName} cant be empty`,
        section: section,
      })
    );
    return;
  }

  // If the value does not match the regex, show validation error
  if (!nameRegex.test(trimmedValue)) {
    setError();
    dispatch(
      errorFunction({
        message: errorMessage || `Valid ${fieldName} is required`,
        section: section,
      })
    );
  } else {
    // Clear errors if validation passes
    dispatch(errorFunction({ message: "", section: section }));
  }
}



//aman
export const numberCheck = (data) => {
  return /^\d+$/.test(data);
};

export const number = (data) => {
  return /^[0-9]+$/.test(data);
};
const regex = /^[a-zA-Z0-9]+$/;

//new 
export const mobileNoValidation = (data, countryCode = "977") => {
  // Remove non-numeric characters
  const normalizedValue = data.replace(/\D/g, "");

  // Check if it starts with the country code and validate the remaining 10 digits
  if (normalizedValue.startsWith(countryCode)) {
    return normalizedValue.length === countryCode.length + 10; // Country code + 10 digits
  }

  // For numbers without country code, validate exactly 10 digits
  return /^\d{10}$/.test(normalizedValue);
};

export const emailCheck = (data) => {
  // return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(data);
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z.]+$/.test(data);
};

export const checkWebsite = (data) => {
  return /^[a-zA-Z0-9.]+$/.test(data);
};

export const alphabetChecker = (data) => {
  return /^[A-Za-z\s]+$/.test(data);
};

export const alphanumericCheck = (data) => {
  return /^[a-zA-Z0-9]+$/.test(data);
};

export const bankAccountNoValidation = (data) => {
  return /^[a-zA-Z0-9]+$/.test(data);
};

export const toleCheck = (data) => {
  return /^[a-zA-Z0-9\s\-(),.]*$/.test(data);
};

//   export const toleCheck = (data) => {
//     if (!data.trim()) {
//         return false; // Empty or whitespace-only input is invalid
//     }
//     return /^[a-zA-Z0-9\s\-(),.]*$/.test(data);
// };

//telephone number only validation is done here 
export const numberCheckTel = (data) => {
  return /^\d+(-\d+)*$/.test(data);
};

// export function alphabetCheck(value, setError, dispatch, errorFunction, section, errorMessage) {
//   const regex = /^[A-Za-z\s]+$/; // Only alphabets and spaces are allowed
//   if (!regex.test(value)) {
//     setError(); // Set error if validation fails
//     dispatch(
//       errorFunction({
//         message: errorMessage || "Incorrect format",
//         section: section,
//       })
//     );
//   }
// }
export function alphabetCheck(value, setError, dispatch, errorFunction, section, errorMessage) {
  const regex = /^[A-Za-z\s]+$/; // Only alphabets and spaces are allowed
  if (!regex.test(value)) {
    setError(); // Set error if validation fails
    if (typeof errorFunction === "function") {
      dispatch(
        errorFunction({
          message: errorMessage || "Incorrect format",
          section: section,
        })
      );
    } else {
      console.error("Error function is not defined properly");
    }
  }
}

// Alphanumeric validation function
export function checkAlphanumeric(value, setError, dispatch, errorFunction, section, errorMessage) {
  const regex = /^[a-zA-Z0-9]+$/;
  // console.log("checkAlphanumeric", value);
  if (!regex.test(value)) {
    setError();
    dispatch(
      errorFunction({
        message: errorMessage || "Only alphanumeric characters are allowed",
        section: section,
      })
    );
  }
}

// Alphanumeric and (.) validation function for website
// export function checkWebsite(value, setError, dispatch, errorFunction, section, errorMessage) {
//   const regex = /^[a-zA-Z0-9]+$/;
//   // console.log("checkWebsite", value);
//   if (!regex.test(value)) {
//     setError();
//     dispatch(
//       errorFunction({
//         message: errorMessage || "Only alphanumeric characters and '.'  are allowed for website",
//         section: section,
//       })
//     );
//   }
// }
